import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyLavoratoriService
 * Client API per la gestione dell'anagrafica lavoratori del modulo
 * "Gestione Adempimenti Sicurezza".
 */
export default class SafetyLavoratoriService {
    static getAll = () => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/lavoratori`;
        return ApiService.getRudeRequest(url);
    };

    static find = (params) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/lavoratori/find`;
            ApiService.postRudeRequest(resolve, reject, url, params);
        });
    };

    static count = (params) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/lavoratori/count`;
            ApiService.postRudeRequest(resolve, reject, url, params);
        });
    };

    static show = (id_lavoratore) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/lavoratori/show`;
            ApiService.postRequest(resolve, reject, url, { id_lavoratore });
        });
    };

    static create = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/lavoratori/create`;
            ApiService.postRequest(resolve, reject, url, data);
        });
    };

    static update = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/lavoratori/update`;
            ApiService.putRequest(resolve, reject, url, data);
        });
    };

    static delete = (id_lavoratore) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/lavoratori/delete`;
            ApiService.delete(resolve, reject, url, { id_lavoratore });
        });
    };

    /**
     * Importa in blocco corsisti eduform (id_utenti) come lavoratori safety,
     * assegnandoli all'azienda indicata. Ritorna { imported, skipped }.
     */
    static importCorsisti = (id_azienda, id_utenti) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/lavoratori/importCorsisti`;
            ApiService.postRequest(resolve, reject, url, { id_azienda, id_utenti });
        });
    };
}
